import React from 'react';

function DischargePackage({ equipment, restrictions, redFlags, socialFactors }) {
  return (
    <div className="discharge-pkg">
      {/* Equipment */}
      {equipment && equipment.length > 0 && (
        <div className="pkg-section">
          <div className="pkg-section-title">DME / Equipment ({equipment.length} items)</div>
          <div className="pkg-equipment-list">
            {equipment.map((eq, i) => (
              <div key={i} className="pkg-equipment-item">
                <div className="pkg-eq-name">{eq.item}</div>
                <div className="pkg-eq-necessity">{eq.medical_necessity}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Restrictions */}
      {restrictions && (
        <div className="pkg-section">
          <div className="pkg-section-title">Discharge Restrictions</div>
          <div className="pkg-restrictions">
            <div className="pkg-restriction-item">
              <span className="pkg-restriction-label">Activity</span>
              <span className="pkg-restriction-text">{restrictions.activity}</span>
            </div>
            <div className="pkg-restriction-item">
              <span className="pkg-restriction-label">Diet</span>
              <span className="pkg-restriction-text">{restrictions.diet}</span>
            </div>
            <div className="pkg-restriction-item">
              <span className="pkg-restriction-label">Driving</span>
              <span className="pkg-restriction-text">{restrictions.driving}</span>
            </div>
          </div>
        </div>
      )}

      {/* Red Flags */}
      {redFlags && redFlags.length > 0 && (
        <div className="pkg-section">
          <div className="pkg-section-title pkg-red-flag-title">Red Flags (Readmission Warning Signs)</div>
          <div className="pkg-red-flags">
            {redFlags.map((flag, i) => (
              <div key={i} className="pkg-red-flag">{flag}</div>
            ))}
          </div>
        </div>
      )}

      {/* Social Factors */}
      {socialFactors && (
        <div className="pkg-section">
          <div className="pkg-section-title">Social Determinants</div>
          <div className="pkg-social">
            {Object.entries(socialFactors).map(([key, val]) => (
              <div key={key} className="pkg-social-item">
                <span className="pkg-social-label">{key.replace(/_/g, ' ')}</span>
                <span className="pkg-social-text">{val}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default DischargePackage;
